import React from "react";
import cns from "classnames";
import { Divider } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import { Small } from "../typography/Small";
import { OptionComponentProps } from "./utils";
import { ThemeType } from "@theme";
import Highlighter from "@components/Highlighter";
import { makeStyles } from "@material-ui/core/styles";

type Props = OptionComponentProps & {
  children?: React.ReactNode;
};

export function SelectOptionMui(props: Props) {
  const classes = useStyles({});

  const {
    isDisabled,
    isGroup,
    isFocused,
    isSelected,
    isGroupOpen,
    handleDropdownItemClick,
    option
  } = props;

  const fontWeight = isSelected ? 500 : 400;

  const searchRe = props.inputValue ? new RegExp(props.inputValue, "i") : null;

  if (option.divider) {
    return <Divider />;
  }

  return (
    <MenuItem
      className={cns(props.className, classes.root, {
        [classes.menuWithDropdownItem]: isGroup,
        [classes.withDesc]: Boolean(option.description)
      })}
      component={"div" as any}
      disabled={isDisabled}
      unselectable="on"
      onClick={
        props.option.unselectable
          ? handleDropdownItemClick
          : () => props.onSelect(props.option)
      }
      onFocus={props.onFocus}
      selected={isFocused}
      style={{
        fontWeight,
        paddingLeft: 8 + props.parentLevel * 2 * 8,
        cursor: option.unselectable ? "default" : "pointer",
        ...option.style
      }}
      data-test="SelectOption"
      data-test-id={option.value}
    >
      {option.hiddenCheckbox ? (
        <Checkbox
          className={classes.checkbox}
          disabled
          style={{ visibility: "hidden" }}
        />
      ) : (
        !option.skipCheckbox && (
          <Checkbox
            checked={isSelected}
            className={classes.checkbox}
            disabled={isDisabled}
          />
        )
      )}

      {option.icon}

      <Highlighter
        search={searchRe}
        // elementStyle={{ whiteSpace: "normal" }}
        style={{ flex: 1, whiteSpace: "normal" }}
      >
        {props.children}
      </Highlighter>

      {isGroup && (
        <div className={classes.dropdownItem} onClick={handleDropdownItemClick}>
          <span
            className={cns(classes.dropdownArrow, {
              [classes.dropdownArrowOpen]: isGroupOpen
            })}
          >
            <svg
              fill="currentColor"
              preserveAspectRatio="xMidYMid meet"
              height="1em"
              width="1em"
              viewBox="0 0 40 40"
              style={{ verticalAlign: "middle" }}
            >
              <g>
                <path d="m11.6 16.6h16.8l-8.4 8.4z" />
              </g>
            </svg>
          </span>
        </div>
      )}

      {props.option.description && (
        <div className={classes.desc}>
          <Small>
            <Highlighter search={searchRe}>{props.option.description}</Highlighter>
          </Small>
        </div>
      )}
    </MenuItem>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    alignItems: "center"
  },

  withDesc: {
    height: "auto",
    padding: 0
  },

  menuWithDropdownItem: {
    position: "relative"
  },

  checkbox: {
    height: "auto",
    width: "auto",
    marginRight: theme.spacing()
  },

  dropdownItem: {
    width: "10%",
    height: "100%",
    position: "relative",
    top: 0,
    right: 0,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  dropdownArrow: {
    transition: "all 0.5s ease-in-out"
  },

  dropdownArrowOpen: {
    transform: "rotate(180deg)"
  },

  desc: {
    flex: "0",
    position: "relative",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: "right"
  }
}));
